export interface DataMapType {
  id: number
  name: DataMapEnum
  dataMapTypeKey: DataMapTypeKey
  code: string
}

export enum DataMapEnum {
  unfundedToFunded = 'Draw from Unfunded',
  interestReserveToFunded = 'Draw from Interest Reserve',
  paymentInKind = 'Payment In Kind',
  capitalizationOfInterest = 'Capitalization of Interest',
}

export type DataMapTypeKey = keyof typeof DataMapEnum

export const DataMapTypes: Record<DataMapEnum, DataMapType> = {
  [DataMapEnum.unfundedToFunded]: {
    id: 1,
    name: DataMapEnum.unfundedToFunded,
    dataMapTypeKey: 'unfundedToFunded',
    code: 'UTF',
  },
  [DataMapEnum.interestReserveToFunded]: {
    id: 2,
    name: DataMapEnum.interestReserveToFunded,
    dataMapTypeKey: 'interestReserveToFunded',
    code: 'IRTF',
  },
  [DataMapEnum.paymentInKind]: {
    id: 3,
    name: DataMapEnum.paymentInKind,
    dataMapTypeKey: 'paymentInKind',
    code: 'PIK',
  },
  [DataMapEnum.capitalizationOfInterest]: {
    id: 4,
    name: DataMapEnum.capitalizationOfInterest,
    dataMapTypeKey: 'capitalizationOfInterest',
    code: 'COI',
  },
}

export const dataMapTypesVal: DataMapType[] = Object.values(DataMapTypes)

export const DRAW_TYPES = [
  DataMapTypes[DataMapEnum.unfundedToFunded],
  DataMapTypes[DataMapEnum.interestReserveToFunded],
  DataMapTypes[DataMapEnum.capitalizationOfInterest],
]

export const BUY_TYPES = [DataMapTypes[DataMapEnum.paymentInKind]]

/**
 * Reserve balance the DRAW is drawn against. Only applicable when none of the
 * Draw Type options (unfundedToFunded / interestReserveToFunded /
 * capitalizationOfInterest) are selected.
 */
export enum ReserveBalanceField {
  INTEREST_BEARING_INTEREST_RESERVE = 'Interest Reserve (Interest Bearing)',
  NON_INTEREST_BEARING_INTEREST_RESERVE = 'Interest Reserve (Non-Interest Bearing)',
  INTEREST_BEARING_PRINCIPAL_RESERVE = 'Principal Reserve (Interest Bearing)',
  NON_INTEREST_BEARING_PRINCIPAL_RESERVE = 'Principal Reserve (Non-Interest Bearing)',
}

export type ReserveBalanceFieldKey = keyof typeof ReserveBalanceField

export const reserveBalanceFieldOptions: string[] = [
  '',
  ...Object.values(ReserveBalanceField),
]

/** Maps a reserveBalanceField label to the enum key persisted on the data map. */
export function reserveBalanceFieldKeyFromLabel(label: string): string {
  const match = Object.entries(ReserveBalanceField).find(
    ([, name]) => name === label,
  )
  return match ? match[0] : ''
}

/** Maps a persisted reserveBalanceField enum key back to its display label. */
export function reserveBalanceFieldLabelFromKey(key?: string): string {
  return key && key in ReserveBalanceField
    ? ReserveBalanceField[key as ReserveBalanceFieldKey]
    : ''
}
